import OutputNodeReadonly from './OutputNodeReadonly'

export default OutputNodeReadonly
